import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Starts every new page at the top. Client-side navigation keeps the scroll
 * position, so a link clicked at the bottom of a long page (the plans page's
 * "request a quote", the closing cards) used to open the next page scrolled
 * down. Keyed on the pathname only: same-page changes to the query or the
 * location state (the tutorial contents, the features deep links) manage
 * their own scrolling.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
